import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import { selectGroupWells } from "../reducers/groupWellSlice";
import { selectLists } from "../reducers/listSlice";
import { selectTypeCurves } from "../reducers/typeCurveSlice";
import { selectWells } from "../reducers/wellSlice";

const useStyles = makeStyles(theme => ({
  root: {
    // backgroundColor: theme.palette.grey[50],
    backgroundColor: 'transparent',
    // width: '100%',
    height: '100%',
    overflow: 'auto',
    padding: 0,
    paddingBottom: 120
  },
  emptyDetails: {
    height: 'calc(100% - 120px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  heading: {
    marginBottom: 20,
    fontSize: 18
  },
}));

function createData(name, value) {
  return { name, value };
};

export const WellCompletions = () => {

  const wells = useSelector(selectWells);
  const classes = useStyles();
  const lists = useSelector(selectLists);
  const list = lists?.byId?.[lists?.currentListId];
  const typeCurves = useSelector(selectTypeCurves);
  const groupWells = useSelector(selectGroupWells);

  const well = list?.forecastListTab === 0 ? wells?.byUwi?.[wells?.currentWellUwi] : 
    list?.forecastListTab === 1 ? typeCurves?.byId?.[list?.typeCurveId] : groupWells?.byId?.[list?.groupWellId];

  const wellDetails = well?.completions;

  const rows = wellDetails && Object.keys(wellDetails) && Object.keys(wellDetails).map(detail => {
    return createData(detail, wellDetails[detail]);
  });
  
  return (
    <Container className={classes.root}>
      <Typography variant="subtitle2" color="textSecondary" style={{marginLeft: 10, marginTop: 10}}>
        {list?.forecastListTab === 0 ? well?.formattedUwi : well?.name}
      </Typography>
      <Typography variant="h6" className={classes.heading} style={{marginLeft: 10}}>
        Completions Details
      </Typography>

      {rows?.length > 0 ?
        <TableContainer component={Paper} style={{marginTop: 20}}>
          <Table>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {formatDetail(row.name) || ""}
                  </TableCell>
                  <TableCell align="right">{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      : 
      <div className={classes.emptyDetails}>
        <Typography variant = "h6" color="textSecondary" style={{marginTop: 20, textAlign: 'center'}}>Completions details not available</Typography>
      </div>}
    </Container> 
  );
};

function formatDetail(detail) {
  try {
    let formattedDetail = detail.split('_');
    formattedDetail.forEach((part, i) => {
      if (part.length > 2) {
        formattedDetail[i] = part.charAt(0).toUpperCase() + part.slice(1);
      };
    });
    return formattedDetail.join(" ");
  } catch (error) {
    return detail;
  };
};